import { Palette } from '@/themes/themeOverrides/Palette';
import CalendarIcon from '@/assets/icons/calendar-icon.svg';
import { breakpoints } from '@/themes/themeOverrides/Breakpoints';

export const MuiTextFieldStyles = {
    defaultProps: {
        variant: 'outlined',
    },
    styleOverrides: {
        root: {
            '& .MuiOutlinedInput-root': {
                borderRadius: '12px',
                backgroundColor: Palette.white,
                fontSize: '14px',
                lineHeight: '20px',
                padding: '12px 16px !important',
                color: Palette.black,
                '& .MuiOutlinedInput-input': {
                    padding: '0px !important',
                    height: 'auto',
                    borderRadius: 0,
                    [`@media (max-width: ${breakpoints.values.md}px)`]: {
                        fontSize: '16px',
                    },
                    '&:-webkit-autofill': {
                        backgroundColor: 'transparent !important',
                        WebkitBoxShadow: '0 0 0px 1000px transparent inset !important',
                        boxShadow: '0 0 0 1000px transparent inset !important',
                    },
                },
                '& svg.MuiSelect-icon.MuiSelect-iconOutlined': {
                    top: 'calc(50% - 2px)',
                    right: '20px',
                    '&.Mui-disabled': {
                        opacity: '0.4',
                    },
                },
                '&.Mui-disabled': {
                    backgroundColor: Palette.gray.gray50,
                    '& .MuiInputBase-input.MuiOutlinedInput-input.Mui-disabled, & .MuiSelect-select.MuiSelect-outlined.Mui-disabled': {
                        color: Palette.black,
                        WebkitTextFillColor: Palette.black,
                        opacity: '1',
                        fontWeight: '600',
                    },
                    '& fieldset': {
                        borderColor: `${Palette.gray.gray100} !important`,
                    },
                    '& .MuiSelect-icon.MuiSelect-iconOutlined.Mui-disabled': {
                        opacity: 1,
                        '& path': {
                            stroke: Palette.gray.gray300,
                        },
                    },
                },
                '& fieldset': {
                    borderColor: Palette.gray.gray200,
                    borderWidth: '2px',
                },
                '&:hover fieldset': {
                    borderColor: Palette.gray.gray300,
                },
                '&.Mui-focused fieldset': {
                    borderColor: Palette.black,
                    boxShadow: `0 0 0 2px ${Palette.yellow.yellow400} !important`,
                    color: 'black !important',
                },
            },
            '&.RaFilterForm-filterFormInput': {
                backgroundColor: 'lightblue',
                borderRadius: '8px',
                padding: '8px',
            },
            '&.date-input': {
                '& .MuiFormLabel-root.MuiInputLabel-root': {
                    transform: 'translate(14px, -11px) scale(1)',
                },
                '& input[type="date"]::-webkit-calendar-picker-indicator': {
                    opacity: 1,
                    display: 'block',
                    backgroundImage: `url("${CalendarIcon}")`,
                    width: '20px',
                    height: '20px',
                    borderWidth: 'thin',
                },
            },
        },
    },
};
